import React, { useState } from 'react';
import CustomTh from '../../../../../components/table/CustomTh';
import CustomTd from '../../../../../components/table/CustomTd';
import { useTranslation } from 'react-i18next';
import TableFunction from '../../../../../components/table/TableFunction';
import { useSelector } from 'react-redux';

const CaptureFingerTable = ({ data, setSelectedList, getAccessMethodName}) => {
    const { t } = useTranslation();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);

    const [tableId, setTableId] = useState("tbl_cft_table");

    const getThead = () => {
        let header = [
            <CustomTh tableId={tableId} className='first_head'>{t('name')}</CustomTh>,
            <CustomTh tableId={tableId}> {t('access_method')}</CustomTh>
        ];
        return header;
    }

    const getTbody = () => {
        if (!data || data?.length === 0) return {
            body: [],
            data: []
        };
        let body = data.map((item) => {
            return (
                <>
                    <CustomTd className='first-column'>{item?.description}</CustomTd>
                    <CustomTd>{getAccessMethodName(item?.accessMethodId)}</CustomTd>
                </>
            );
        });

        return {
            body: body,
            data: data
        }
    };


    const { thead, tbody, handleCheckboxChange } = TableFunction({
        setSelectedList:setSelectedList,
        data: { content: data },
        getTbody: getTbody,
        getThead: getThead
    });


    return {
        t, DEV,
        thead, tbody,
        tableId,
        handleCheckboxChange
    };

}
export default CaptureFingerTable;
